import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { FleetManagerForm } from "./FleetManagerForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IFleetManagerCreateProps {}

export const FleetManagerCreate = (props: IFleetManagerCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.FleetManager,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-fleet-managers.title.create">
        <FleetManagerForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
